import { Route } from 'interfaces/contracts/wrappedIrm'
import { IIRM } from 'interfaces/irm.interface'
import { BaseLcdService } from './base/baseLcdService'

// Remove FCD if not use
export class IrmService extends BaseLcdService {
  //   constructor() {
  //     super()
  //   }

  getRoutes = async (wrapperAddr: string) => {
    const msg = {
      routes: {},
    }

    const response = await this.contractQuery<(string | Route)[][]>(
      wrapperAddr,
      msg,
    )

    let result: Record<string, Route> = {}
    response.forEach(
      (res) => (result = { ...result, [res[0] as string]: res[1] as Route }),
    )

    return result
  }

  getIRMConfig = async (irmAddr: string) => {
    const msg = {
      config: {},
    }

    return await this.contractQuery<IIRM>(irmAddr, msg)
  }
}

export const irmService = new IrmService()
